import { useState, useEffect, useRef, useMemo } from "react";
import Button from '@mui/material/Button';
import authHeader from "../services/auth-header";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import { MapContainer, TileLayer,  Popup, Marker } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import axios from "axios";
import AuthService from "../services/auth.service";

import { iconPerson } from "../components/map/Icon.js"

import { useTranslation } from "react-i18next";

import ReactDOM from "react-dom";

const api = require("../api/names.js");

function ParkingNew() {

    const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [parkingName, setParkingName] = useState("piaseczno-UM");
    const [description, setDescription] = useState("Obok UM (14szt)");
    const [lat, setLat] = useState("52.07358455347315");
    const [lon, setLon] = useState("21.027831333798638");
    const [userID, setUserID] = useState(null);

    const [position, setPosition] = useState({ lat: 52.07358455347315, lng: 21.027831333798638 })
    const markerRef = useRef(null)

    const [bt1, setBt1] = useState(0);

    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    setPosition(marker.getLatLng())
                }
            },

        }),
        [],
    )

    useEffect(() => {

        const user = AuthService.getCurrentUser();
        if(user)
        {
            setUserID(user.id);
            setIsLoaded(true);
        }
        else
        {
            setIsLoaded(true);
            setError({message : "no user"});
        }    

    }, []);

    function buttonIsDisabled(prop) {
        if (prop === 0)
            return false;
        else
            return true;
    }

    function buttonColor(prop) {
        if (prop === 0)
            return { backgroundColor: "white" };
        else if (prop === 1)
            return { backgroundColor: "red", color: "white" };
        else
            return { backgroundColor: "green", color: "white" };
    }

    function buttonLabel(prop) {
        if (prop === 0)
            return "Add new parking";
        else if (prop === 1)
            return "Error";
        else
            return "Complete";
    }

    function savepos() {
        setLat(position.lat);
        setLon(position.lng);
    }

    const nameHandler = (e) => {
        var txt = e.target.value;
        setParkingName(txt);
    }

    const descHandler = (e) => {
        var txt = e.target.value;
        setDescription(txt);
    }

    const latHandler = (e) => {
        var txt = e.target.value;
        setLat(txt);
    }

    const lonHandler = (e) => {
        var txt = e.target.value;
        setLon(txt);
    }

    function save() {
        var url = api.baseUrl + '/parkings';
        const jsonData = {
            "parkingName": parkingName,
            "description": description,
            "gpsLatitude": lat,
            "gpsLongtitude": lon,
            "userID": userID
        }
        axios.post(url, jsonData, { headers: authHeader() });
        setBt1(2);
        setTimeout(() => setBt1(0), 2000);
    }

    if (error) {
        return <div>{t('detectord.error')}{error.message}</div>;
    } else if (!isLoaded) {
        return <div>{t('detectord.loading')}</div>;
    } else {

        return (
            <div>
                <br />
                <Button href='/parkings' variant="outlined" startIcon={<ArrowBackIcon />}>
                    {t('parkingd.comeback')}
                </Button>
                <br />
                <br />
                <TextField size="large" id="parkingname" onChange={nameHandler} label="Parking Name" defaultValue={parkingName} />
                <TextField size="large" id="parkingdesc" onChange={descHandler} label="Parking Description" defaultValue={description} />
                <TextField size="large" id="lat" value={lat} onChange={latHandler} label="Latitude" defaultValue={lat} />
                <TextField size="large" id="lon" value={lon} onChange={lonHandler} label="Longitude" defaultValue={lon} />
                <br />
                <br />
            <MapContainer className="map" center={[lat, lon]} zoom={21} scrollWheelZoom={true}>
                <TileLayer
                    maxZoom={19}
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
            
                    <Marker
                        draggable={true}
                        eventHandlers={eventHandlers}
                        position={position}
                        ref={markerRef}
                        icon={iconPerson}>
                        <Popup minWidth={90}>
                            <span>
                                Center of the parking
                            </span><br />
                            <span>
                                Lat: {position.lat}
                            </span><br />
                            <span>
                                Lng: {position.lng}
                            </span><br />
                            <span type="button" onClick={savepos}>
                                Save
                            </span>
                        </Popup>
                    </Marker>

            </MapContainer>
            <br />
            <Button href='/parkings' onClick={save} variant="outlined" startIcon={<AddIcon />} style={buttonColor(bt1)} disabled={buttonIsDisabled(bt1)}>
                {buttonLabel(bt1)}
            </Button>

        </div>
        );
    }
}

export default ParkingNew;

ReactDOM.render(<ParkingNew />, document.getElementById("root"));
